import React from "react";
import MinicartContent$ from "@deosite/components-new/MinicartContent";
import Button from "@deosite/components-new/buttons/Button";

const MinicartContent = props => {
  const propsExt = {
    ...props,
    checkoutButton: <Button />
  };

  return <MinicartContent$ {...propsExt} />;
};

export default MinicartContent;
